import { render, staticRenderFns } from "./MousePointer.vue?vue&type=template&id=4e97dc34&"
import script from "./MousePointer.vue?vue&type=script&lang=js&"
export * from "./MousePointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports